module.exports = __webpack_public_path__ + "assets/20.jpg?31287f1a79c128368c41fa51e5f6f045";